import React from 'react'
import styles from './styles.module.css'
import cn from 'classnames'


export default function Checkbox({ label, withPadding, gradeWeight, className, error, ...props }) {

  const checkboxClassObject = cn(
    styles.label, styles.checkbox, className,
    { [styles.error]: error }
  )

  return (
    <label className={cn([withPadding ? styles.methodOffice : checkboxClassObject])} style={gradeWeight && { margin: "0 auto" }}>
      <input type='checkbox' {...props} />
      <p>{label}</p>
    </label>
  )
}
